/* eslint-disable react/destructuring-assignment */
import React, { useEffect } from 'react';
import { Button, Grid } from '../../canvasComponents/index';
import { injectIntl, FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';
// styling
import '../../css/domain/Final/final.scss';
// redux
import { connect, useDispatch } from 'react-redux';
import { claimsDataSelector } from '../../redux/Claims/selector';
import { submitClaim } from '../../redux/Claims/actions';
// icons
import givingBack from '../../img/global/givingBack.svg';
// svg animations
import SucessAnimation from './successAnimation';
// messages
import messages from './messages';
// Analytics
import * as FS from '../../analytics/fullstory';
import * as GA from '../../analytics/googleanalytics';
// utils
import * as events from '../../utils/constants/formEvents';

function Final(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { claimId } = props;
  const claims = props.claims.data;

  // init GTM
  const sendDataToGTM = useGTMDispatch();

  // Claim information extraction if claim ID exists in claims array
  const currentClaim = claims.find((claim) => claim.claimId === claimId) || null;
  const claimNumber = currentClaim?.cdsClaimNumber || currentClaim?.gwClaimNumber;
  const claimType = currentClaim?.submittedData?.claim_type?.claim_type;
  const isABonly = claimType === 'Vehicle' && currentClaim.submittedData.claim_type.vehicle?.policySystemId === 'injuryOnly';
  const nesteForm = isABonly ? 'abonly' : 'auto';
  const lossCause = currentClaim.submittedData?.[nesteForm]?.data?.lossCause?.value;

  // check if injury claim
  const peopleInjured = currentClaim.submittedData?.[nesteForm]?.data?.injuredInjuries?.whatAreTheInjuriesInfo.length > 0 ? currentClaim.submittedData[nesteForm]?.data.injuredInjuries.whatAreTheInjuriesInfo : [];
  const driver = currentClaim.submittedData?.[nesteForm]?.data?.driverIsInjured?.value;
  const passenger = currentClaim.submittedData?.[nesteForm]?.data?.passengers?.addPassengerInfo.length > 0 ? currentClaim.submittedData[nesteForm]?.data.passengers.addPassengerInfo : [];
  const injuryCondition1 = peopleInjured.find((person) => person.selectAllInjuriesApply.selectedValues.includes('brokenBones') || person.selectAllInjuriesApply.selectedValues.includes('unconsciousAfterTheAccident') || person.selectAllInjuriesApply.selectedValues.includes('airliftedFromScene') || person.selectAllInjuriesApply.selectedValues.includes('lossOfLife') || person.wereAnyOfTheFollowingItemsDamaged.selectedValues.length > 0);
  const injuryCondition2 = peopleInjured.find((person) => (person.selectAllInjuriesApply.selectedValues.includes('stiffAndSore') || person.selectAllInjuriesApply.selectedValues.includes('cutsAndBruises')) && (person.followingApply.selectedValues.includes('willBeGoingForTreatment') || person.followingApply.selectedValues.includes('needToTakeTimeOffWork')));
  const injuryCondition3 = passenger.find((person) => person.isInjured.value);

  const injuryLossCauses = ['single_vehicle', 'multi_vehicle', 'occupantThirdPartyVehicle', 'injuredPedestrianOrCyclist'];
  const noInjuryLossCauses = ['weather_events', 'random', 'crime'];

  useEffect(() => {
    window.history.pushState({}, window.location.pathname, claimType === 'Vehicle' ? '#/claims/auto/submit-claim' : '#/claims/property/submit-claim');
  }, [claimType]);

  useEffect(() => {
    submitHandler(currentClaim.gwClaimId);
  }, []);

  const submitHandler = (cid) => {
    if (currentClaim?.submittedData?.lossDetailsConfirmed) {
      const claimStatus = events.FORM_EVENT_SUBMITTED;
      // send fullstory and google analytics event
      sendDataToGTM(GA.sendEventData('submitClaim', currentClaim, claimStatus));
      FS.sendEventData(currentClaim, claimStatus);
      dispatch(submitClaim(cid));
    }
  };

  return (
    <div className="final-page-container">
      {/* AUTO - WITH INJURED PEOPLE */}
      {(noInjuryLossCauses.includes(lossCause) || (injuryLossCauses.includes(lossCause) && (injuryCondition1 || injuryCondition2))) && (
        <Grid>
          <Grid.Row>
            <div className="page-title"><FormattedMessage {...messages.title} /></div>
          </Grid.Row>
          <div className="phone-animation">
            <Grid.Row>
              <div className="container-animation-phone">
                <SucessAnimation />
              </div>
            </Grid.Row>
          </div>
          <div className="card-rising-animation">
            <Grid.Row>
              <div className="final-divider">
                <div className="animation-text-grid">
                  <div className="text-grid">
                    <div className="page-reference">
                      <FormattedMessage {...messages.reference1} />
                      <span className="colored-text">
                        <FormattedMessage
                          {...messages.referenceNumber}
                          values={{ referenceNumber: claimNumber }}
                        />
                      </span>.
                    </div>
                    <div className="page-subtitle"><FormattedMessage {...messages.subtitleHappenNext} /></div>
                    <div className="page-text">
                      <ul className="page-list">
                        <li><FormattedMessage {...messages.happenNextLi5} /></li>
                        <li><FormattedMessage {...messages.happenNextLi7} /></li>
                      </ul>
                    </div>
                  </div>
                  <div className="container-animation">
                    <SucessAnimation />
                  </div>
                </div>
                <div className="page-subtitle"><FormattedMessage {...messages.subtitleRemember} /></div>
                <div className="page-text">
                  <ul className="page-list">
                    <li><FormattedMessage {...messages.rememberLi1} /></li>
                    <li><FormattedMessage {...messages.rememberLi2} /></li>
                  </ul>
                </div>
                <div className="image-text">
                  <div className="page-text"><FormattedMessage {...messages.sonnetEconomicalExperience} /></div>
                  <img className="give-back-logo" src={givingBack} alt="Give it Back Logo" />
                </div>
                <div className="page-subtitle"><FormattedMessage {...messages.contact} /></div>
              </div>
            </Grid.Row>
          </div>
          <Grid.Row>
            <div className="centered-text">
              <Button
                primary
                className="back-btn"
                onClick={() => navigate('/dashboard')}
              >
                <FormattedMessage {...messages.backToDashboard} />
              </Button>
            </div>
            <div className="small-info"><FormattedMessage {...messages.informationSecured} /></div>
          </Grid.Row>
        </Grid>
      )}

      {/* AUTO - WITH NO INJURED PEOPLE */}
      {(injuryLossCauses.includes(lossCause) && !(injuryCondition1 || injuryCondition2) && !isABonly) && (
        <Grid>
          <Grid.Row>
            <div className="page-title"><FormattedMessage {...messages.title} /></div>
          </Grid.Row>
          <div className="phone-animation">
            <Grid.Row>
              <div className="container-animation-phone">
                <SucessAnimation />
              </div>
            </Grid.Row>
          </div>
          <div className="card-rising-animation">
            <Grid.Row>
              <div className="final-divider">
                <div className="animation-text-grid">
                  <div className="text-grid">
                    <div className="page-reference">
                      <FormattedMessage {...messages.reference3} />
                      <span className="colored-text">
                        <FormattedMessage
                          {...messages.referenceNumber}
                          values={{ referenceNumber: claimNumber }}
                        />
                      </span>.
                    </div>
                    {((driver || injuryCondition3) && (
                    <div className="page-subtitle"><FormattedMessage {...messages.reference2} /></div>))}
                    <div className="page-subtitle"><FormattedMessage {...messages.subtitleHappenNext} /></div>
                    <div className="page-text">
                      <ul className="page-list">
                        <li><FormattedMessage {...messages.happenNextLi1} /></li>
                        <li><FormattedMessage {...messages.happenNextLi2} /></li>
                        <li><FormattedMessage {...messages.happenNextLi3} /></li>
                        <li><FormattedMessage {...messages.happenNextLi4} /></li>
                      </ul>
                    </div>
                  </div>
                  <div className="container-animation">
                    <SucessAnimation />
                  </div>
                </div>
                <div className="page-subtitle"><FormattedMessage {...messages.subtitleRemember} /></div>
                <div className="page-text">
                  <ul className="page-list">
                    <li><FormattedMessage {...messages.rememberLi1} /></li>
                    <li><FormattedMessage {...messages.rememberLi2} /></li>
                  </ul>
                </div>
                <div className="image-text">
                  <div className="page-text"><FormattedMessage {...messages.sonnetEconomicalExperience} /></div>
                  <img className="give-back-logo" src={givingBack} alt="Give it Back Logo" />
                </div>
                <div className="page-subtitle"><FormattedMessage {...messages.contact} /></div>
              </div>
            </Grid.Row>
          </div>
          <Grid.Row>
            <div className="centered-text">
              <Button
                primary
                className="back-btn"
                onClick={() => navigate('/dashboard')}
              >
                <FormattedMessage {...messages.backToDashboard} />
              </Button>
            </div>
            <div className="small-info"><FormattedMessage {...messages.informationSecured} /></div>
          </Grid.Row>
        </Grid>
      )}

      {/* AUTO - INJURY ONLY - WITH NO INJURED PEOPLE */}
      {(!(injuryCondition1 || injuryCondition2) && isABonly) && (
        <Grid>
          <Grid.Row>
            <div className="page-title"><FormattedMessage {...messages.title2} /></div>
          </Grid.Row>
          <div className="phone-animation">
            <Grid.Row>
              <div className="container-animation-phone">
                <SucessAnimation />
              </div>
            </Grid.Row>
          </div>
          <div className="card-rising-animation">
            <Grid.Row>
              <div className="final-divider">
                <div className="animation-text-grid">
                  <div className="text-grid">
                    <div className="page-subtitle"><FormattedMessage {...messages.reference2} /></div>
                    <div className="page-subtitle"><FormattedMessage {...messages.subtitleNeedToKnow} /></div>
                    <div className="page-text">
                      <ul className="page-list">
                        <li><FormattedMessage {...messages.happenNextLi1} /></li>
                        <li><FormattedMessage {...messages.happenNextLi4} /></li>
                        <li><FormattedMessage {...messages.happenNextLi8} /></li>
                      </ul>
                    </div>
                  </div>
                  <div className="container-animation">
                    <SucessAnimation />
                  </div>
                </div>
                <div className="page-subtitle"><FormattedMessage {...messages.contact1} /></div>
              </div>
            </Grid.Row>
          </div>
          <Grid.Row>
            <div className="centered-text">
              <Button
                primary
                className="back-btn"
                onClick={() => navigate('/dashboard')}
              >
                <FormattedMessage {...messages.backToDashboard} />
              </Button>
            </div>
            <div className="small-info"><FormattedMessage {...messages.informationSecured} /></div>
          </Grid.Row>
        </Grid>
      )}

      {/* PROPERTY */}
      {claimType === 'Home' && (
        <Grid>
          <Grid.Row>
            <div className="page-title"><FormattedMessage {...messages.title} /></div>
          </Grid.Row>
          <div className="phone-animation">
            <Grid.Row>
              <div className="container-animation-phone">
                <SucessAnimation />
              </div>
            </Grid.Row>
          </div>
          <div className="card-rising-animation">
            <Grid.Row>
              <div className="final-divider">
                <div className="animation-text-grid">
                  <div className="text-grid">
                    <div className="page-reference">
                      <FormattedMessage {...messages.reference1} />
                      <span className="colored-text">
                        <FormattedMessage
                          {...messages.referenceNumber}
                          values={{ referenceNumber: claimNumber }}
                        />
                      </span>.
                    </div>
                    <div className="page-subtitle"><FormattedMessage {...messages.subtitleHappenNext} /></div>
                    <div className="page-text">
                      <ul className="page-list">
                        <li><FormattedMessage {...messages.happenNextLi5} /></li>
                        <li><FormattedMessage {...messages.happenNextLi6} /></li>
                      </ul>
                    </div>
                  </div>
                  <div className="container-animation">
                    <SucessAnimation />
                  </div>
                </div>
                <div className="page-subtitle"><FormattedMessage {...messages.subtitleRemember} /></div>
                <div className="page-text">
                  <ul className="page-list">
                    <li><FormattedMessage {...messages.rememberLi1} /></li>
                    <li><FormattedMessage {...messages.rememberLi2} /></li>
                  </ul>
                </div>
                <div className="image-text">
                  <div className="page-text"><FormattedMessage {...messages.sonnetEconomicalExperience} /></div>
                  <img className="give-back-logo" src={givingBack} alt="Give it Back Logo" />
                </div>
                <div className="page-subtitle"><FormattedMessage {...messages.contact} /></div>
              </div>
            </Grid.Row>
          </div>
          <Grid.Row>
            <div className="centered-text">
              <Button
                primary
                className="back-btn"
                onClick={() => navigate('/dashboard')}
              >
                <FormattedMessage {...messages.backToDashboard} />
              </Button>
            </div>
            <div className="small-info"><FormattedMessage {...messages.informationSecured} /></div>
          </Grid.Row>
        </Grid>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  claims: claimsDataSelector(state.claims),
});

export default injectIntl(connect(mapStateToProps)(Final));
